import React from "react";

const TodoList = ({ lists, deleteTodo, completeTodo }) => {
  const renderedTodo = lists.map((list, index) => {
    const handleDelete = () => {
      deleteTodo(index);
    };

    const complete = list.isCompleted
      ? "line-through bg-yellow-300"
      : "bg-blue-100 transition duration-150 ease-in-out transform hover:-translate-y-1";

    const handleCompleteTodo = () => {
      completeTodo(index);
    };

    return (
      <div className="w-full flex" key={index}>
        <div
          className={`mb-2 px-2 py-1 cursor-pointer font-semibold w-11/12 mr-2 shadow rounded-sm ${complete}`}
          onClick={handleCompleteTodo}
        >
          {list.todo}
        </div>
        <button
          className="w-1/12 transition duration-150 ease-in-out transform hover:-translate-y-1 border-0 h-8 bg-red-600 text-white font-semibold text-md shadow rounded-sm"
          onClick={handleDelete}
        >
          X
        </button>
      </div>
    );
  });

  return <div className="w-full mt-2 ">{renderedTodo}</div>;
};

export default TodoList;
